import type { FlowFilterNodeConfig } from '@reflex/flows';
import { FILTER_OP_SYMBOLS } from '../../shared/describe-filter';
import { FlowNodeBase } from './FlowNodeBase';

interface FlowFilterNodeData {
  label: string;
  status: string;
  config: FlowFilterNodeConfig;
}

export function FlowFilterNode({
  data,
  selected,
}: {
  data: FlowFilterNodeData;
  selected?: boolean;
}) {
  const config = data.config;
  const conditions = config.mode === 'conditions' ? (config.conditions ?? []) : [];
  const shown = conditions.slice(0, 3);
  const extra = conditions.length - shown.length;

  return (
    <FlowNodeBase
      nodeType="filter"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
      footer="stops the branch when it doesn't match"
    >
      {config.mode === 'conditions' && shown.length > 0 && (
        <div className="flex flex-col gap-0.5" data-testid="filter-node-conditions">
          {shown.map((c, i) => (
            <code
              key={`${c.path}-${i}`}
              className="truncate rounded bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground"
            >
              {c.path} {FILTER_OP_SYMBOLS[c.op]}
              {c.value !== undefined
                ? ` ${Array.isArray(c.value) ? c.value.join(', ') : String(c.value)}`
                : ''}
            </code>
          ))}
          {extra > 0 && (
            <span className="text-[10px] text-muted-foreground">
              +{extra} more ({config.match === 'any' ? 'any' : 'all'} must match)
            </span>
          )}
        </div>
      )}
      {config.mode === 'expression' && (
        <code
          className="block truncate rounded bg-muted/50 px-1.5 py-0.5 font-mono text-[11px] text-foreground/80"
          data-testid="filter-node-expression"
        >
          {config.expression}
        </code>
      )}
      {config.mode === 'conditions' && shown.length === 0 && (
        <span className="text-[10px] text-muted-foreground">No conditions, passes everything</span>
      )}
    </FlowNodeBase>
  );
}
